import { createContext, useContext } from 'react';
import  { useClickModalHelper} from "./hooks/useClickModal";


const ClickModalContext = createContext<any>(null);

export const ClickModalProvider = ({ children }: { children: React.ReactNode }) => {
    const modal = useClickModalHelper();

    return (
        <ClickModalContext.Provider value={modal}>
            {children}
        </ClickModalContext.Provider>
    );
};

export const useClickModalContext = () => {
    const context = useContext(ClickModalContext);
    if (!context) {
        throw new Error('useClickModalContext must be used within a ClickModalProvider');
    }
    return context;
}